import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { categoryInitialValue, categoryValidationSchema, moneyRateInitialValue, moneyRateValidationSchema, subCategoryInitialValue, subCategoryValidationSchema } from '../.././common/Validation';
import Spinwheel from '../.././common/Spinwheel'; 
import Header from '../.././common/Header';
import { Link, useNavigate } from 'react-router-dom';

import toast from 'react-hot-toast';
import { ImageUrl } from './../../../utils/BaseUrl';
import { addMoneyExchangeRateApi, createOrUpdateCategoryApi, getMoneyExchangeRateApi, updateMoneyExhangeRateApi } from '../../../utils/ApiEndpointFunctions';
import ExchangeRateModal from './ExchangeRateModal';

function MoneyRate() {
  const [loader, setLoader] = useState(true)
  const [tableData, setTableData] = useState([])
  const addOrUpdateRateModal = "addOrUpdateRateModalID"
  const [submitLoader, setSubmitLoader] = useState(false)


  const formik = useFormik({
    initialValues: moneyRateInitialValue,
    onSubmit: async (values) => {
      try {
        const payload = { ...values }
        setSubmitLoader(true)
        const res = values._id ? await updateMoneyExhangeRateApi(payload) : await addMoneyExchangeRateApi(payload);
        if (res.status === 200) {
          toast.success(res.data?.message)

          document.getElementById(addOrUpdateRateModal).click()
          getMoneyExchangeRate();
        }

      } catch (error) {
        console.log(error)
        toast.error(error?.response?.data?.message || "Something went wrong.")
      }

      setSubmitLoader(false)
    },
    validationSchema: moneyRateValidationSchema,
  })

  const getMoneyExchangeRate = async (type) => {
    try {
      setLoader(true)
      const res = await getMoneyExchangeRateApi(type = "news")
      if (res.status === 200) {
        // console.log(res.data?.data)
        setTableData(res.data?.data)
      }
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }




  useEffect(() => {
    getMoneyExchangeRate();

  }, [])

  return (
    <>
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Money changer" />
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/transfers">
                    Money changer
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Rate
                </li>
              </ol>
            </nav>
          </div>
          <div className="mb-4" style={{ textAlign: "end" }}>
            <div style={{ display: "-webkit-inline-box" }}>

              <div className="ms-2">
                {/* <button className="btn-custom" data-bs-toggle="modal" data-bs-target={`#${addOrUpdateRateModal}`} onClick={() => { formik.resetForm(); }} >Add</button> */}
              </div>

            </div>
          </div>
          <div className="card p-3 table-responsive" >
            <table className="table table-md table-hover card-table">
              <thead>
                <tr>
                  <th>
                    <span
                      className="list-sort text-muted"
                    >
                      S.No
                    </span>
                  </th>


                  <th>
                    <span
                      className="list-sort text-muted"
                    >
                      Currency
                    </span>
                  </th>
                  <th>
                    <span
                      className="list-sort text-muted"
                    >
                      Exchange currency
                    </span>
                  </th>
                  <th>
                    <span
                      className="list-sort text-muted"
                    >
                      Buy value
                    </span>
                  </th>

                  <th colSpan={2}>
                    <span
                      className="list-sort text-muted"
                    >
                      Sell value
                    </span>
                  </th>
                </tr>
              </thead>
              {loader ? (
                <tbody>
                  <tr>
                    <td colSpan={12} className='text-center'>
                      <Spinwheel />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody className="list fs-base">
                  {tableData?.length > 0 ? (
                    tableData?.map((ele, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{ele?.currency}</td>
                        <td>{ele?.exchangeCurrency}</td>
                        <td>{ele?.buyValue}</td>
                        <td>{ele?.saleValue}</td>
                        <td>
                          <div className="dropdown text-center">
                            <button
                              className=" border-0 bg-white"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16"
                              >
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                              </svg>
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{ zIndex: "1000" }}
                            >
                              <li
                                onClick={() => { formik.setValues(ele) }}
                                data-bs-toggle="modal"
                                data-bs-target={`#${addOrUpdateRateModal}`}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="dropdown-item" >
                                  Edit
                                </span>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td align="center" colSpan="12">
                        <h1>Data Not Found</h1>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
      <ExchangeRateModal modalId={addOrUpdateRateModal} formik={formik} addLoader={submitLoader} />
    </>
  )
}

export default MoneyRate